

import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { FontSizes, FontWeights } from 'office-ui-fabric-react/lib/Styling';
import { Text as FabricText } from 'office-ui-fabric-react/lib/Text';

const Text = (props) => {

    const getColor = () => {
        return (props.color) ? props.color : undefined;
    }

    const getFontSize = () => {
        let size = FontSizes.size14 || FontSizes.medium;
        if (props.xSmall) {
            size = FontSizes.size10 || FontSizes.xSmall;
        }
        if (props.small) {
            size = FontSizes.size12 || FontSizes.small;
        }
        if (props.large) {
            size = FontSizes.size18 || FontSizes.large;
        }
        if (props.xLarge) {
            size = FontSizes.size20 || FontSizes.xLarge;
        }
        if (props.xxLarge) {
            size = FontSizes.size28 || FontSizes.xxLarge;
        }
        if (props.xxxLarge) {
            size = FontSizes.size42 || FontSizes.xxxLarge;
        }
        if (props.mega) {
            size = FontSizes.size68 || FontSizes.mega;
        }
        return size;
    }

    const getFontWeight = () => {
        return (props.bold) ? FontWeights.semibold : FontWeights.regular;
    }

    const classNames = mergeStyleSets({
        Text: {
            fontSize: getFontSize(),
            fontWeight: getFontWeight(),
            color: getColor()
        }
    });

    let className = classNames.Text;
    if (props.className) {
        className = `${className} ${props.className}`;
    }

    return (
        <FabricText
            className={className}
            nowrap={!!props.ellipsis || props.nowrap}
            block={!!props.ellipsis}
            title={props.title}
        >
            {props.children}
        </FabricText>
    );
};

export default Text;

